<template>
  <base-creation-page v-if="insertData" :insertData="insertData" />
</template>

<script>
  export default {
    setup() {
      //structure of page
      const insertData = {
        title: 'Inserimento nuovo tipo di stato allarme',
        redirect_path: '/alarm/alarmTypes',
        create_endpoint: 'createAlarmStatusType',
        creation_title: 'Creazione tipo di stato allarme',
        //dispatchName: "getTrackers",
        data: [
          {
            title: 'user.name.first',
            name: 'name',
            required: true,
          },
        ],
      };
      //return fields
      return {
        insertData,
      };
    },
  };
</script>

<style></style>
